// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

/* CSS Variables for theming */
:root {
  --primary-bg: #282c34;
  --secondary-bg: #f0f0f0;
  --primary-text: #ffffff;
  --secondary-text: #333333;
  --accent-color: #f89859;
  --error-color: #ff4444;
  --success-color: #4CAF50;
  --border-radius: 10px;
  --transition-speed: 0.3s;
  --max-width: 1200px;
  --container-padding: 20px;
  --border-color: #dfe6e9;
}

/* Base styles */
.App {
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Container for content */
.App-container {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--container-padding);
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Header styles */
.App-header {
  background-color: var(--primary-bg);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: calc(10px + 2vmin);
  color: var(--primary-text);
  padding: 2rem;
}

/* Navigation styles */
.main-nav {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius);
}

.nav-link {
  color: var(--primary-text);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  transition: all var(--transition-speed) ease;
}

.nav-link:hover,
.nav-link.active {
  background-color: var(--accent-color);
  color: var(--primary-bg);
}

/* Home container styles */
.home-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

/* Logo styles */
.App-logo {
  height: 40vmin;
  max-height: 300px;
  pointer-events: none;
  transition: transform var(--transition-speed) ease;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

/* Title styles */
.App-title {
  font-size: clamp(1.5rem, 5vw, 2.5rem);
  margin-bottom: 2rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

/* External links styles */
.external-links {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

/* Link styles */
.App-link {
  color: var(--accent-color);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  transition: all var(--transition-speed) ease;
  position: relative;
}

.App-link:hover,
.App-link:focus {
  background-color: var(--accent-color);
  color: var(--primary-bg);
  transform: translateY(-2px);
  outline: none;
}

.App-link:focus-visible {
  outline: 2px solid var(--accent-color);
  outline-offset: 2px;
}

/* FizzBuzz component styles */
.fizzbuzz-container {
  background-color: var(--secondary-bg);
  padding: 2rem;
  border-radius: var(--border-radius);
  margin-top: 2rem;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.fizzbuzz-title {
  font-size: clamp(1.2rem, 4vw, 1.8rem);
  color: var(--secondary-text);
  margin-bottom: 1rem;
  font-weight: bold;
}

.fizzbuzz-sequence {
  font-size: clamp(1rem, 3vw, 1.2rem);
  color: var(--secondary-text);
  line-height: 1.6;
}

/* Input styles */
input[type="number"] {
  background-color: var(--accent-color);
  color: var(--primary-text);
  border: none;
  padding: 0.8rem 1.2rem;
  border-radius: var(--border-radius);
  margin-top: 1rem;
  font-size: 1rem;
  width: 100%;
  max-width: 300px;
  transition: all var(--transition-speed) ease;
}

input[type="number"]:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--primary-bg);
  transform: scale(1.02);
}

input[type="number"]::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

/* Weather display styles */
.weather-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  width: 100%;
  max-width: 800px;
  margin: 2rem auto;
}

.weather-item {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: var(--border-radius);
  transition: transform var(--transition-speed) ease;
}

.weather-item:hover {
  transform: translateY(-5px);
}

/* Error message styles */
.error-message {
  color: var(--error-color);
  background-color: rgba(255, 68, 68, 0.1);
  padding: 1rem;
  border-radius: var(--border-radius);
  margin: 1rem 0;
  width: 100%;
  max-width: 600px;
}

/* Loading state styles */
.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-left-color: var(--accent-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

/* Animations */
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .App-header {
    padding: 1rem;
  }

  .weather-container {
    grid-template-columns: 1fr;
  }

  .fizzbuzz-container {
    padding: 1.5rem;
  }

  .main-nav {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .App-logo {
    height: 30vmin;
  }

  .App-title {
    font-size: 1.8rem;
  }

  input[type="number"] {
    padding: 0.6rem 1rem;
  }
}

/* Print styles */
@media print {
  .App-header {
    background-color: white;
    color: black;
  }

  .App-link {
    color: black;
    text-decoration: underline;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,cAAc;EACd,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;;EAEE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,mCAAmC;EACnC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC,aAAa;EACb,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,mCAAmC;EACnC,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF","sourcesContent":["/* App.css */\n\n/* CSS Variables for theming */\n:root {\n  --primary-bg: #282c34;\n  --secondary-bg: #f0f0f0;\n  --primary-text: #ffffff;\n  --secondary-text: #333333;\n  --accent-color: #f89859;\n  --error-color: #ff4444;\n  --success-color: #4CAF50;\n  --border-radius: 10px;\n  --transition-speed: 0.3s;\n  --max-width: 1200px;\n  --container-padding: 20px;\n  --border-color: #dfe6e9;\n}\n\n/* Base styles */\n.App {\n  text-align: center;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Container for content */\n.App-container {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: var(--container-padding);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Header styles */\n.App-header {\n  background-color: var(--primary-bg);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: calc(10px + 2vmin);\n  color: var(--primary-text);\n  padding: 2rem;\n}\n\n/* Navigation styles */\n.main-nav {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: var(--border-radius);\n}\n\n.nav-link {\n  color: var(--primary-text);\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius);\n  transition: all var(--transition-speed) ease;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  background-color: var(--accent-color);\n  color: var(--primary-bg);\n}\n\n/* Home container styles */\n.home-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n/* Logo styles */\n.App-logo {\n  height: 40vmin;\n  max-height: 300px;\n  pointer-events: none;\n  transition: transform var(--transition-speed) ease;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n/* Title styles */\n.App-title {\n  font-size: clamp(1.5rem, 5vw, 2.5rem);\n  margin-bottom: 2rem;\n  font-weight: bold;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* External links styles */\n.external-links {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n/* Link styles */\n.App-link {\n  color: var(--accent-color);\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius);\n  transition: all var(--transition-speed) ease;\n  position: relative;\n}\n\n.App-link:hover,\n.App-link:focus {\n  background-color: var(--accent-color);\n  color: var(--primary-bg);\n  transform: translateY(-2px);\n  outline: none;\n}\n\n.App-link:focus-visible {\n  outline: 2px solid var(--accent-color);\n  outline-offset: 2px;\n}\n\n/* FizzBuzz component styles */\n.fizzbuzz-container {\n  background-color: var(--secondary-bg);\n  padding: 2rem;\n  border-radius: var(--border-radius);\n  margin-top: 2rem;\n  width: 100%;\n  max-width: 600px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.fizzbuzz-title {\n  font-size: clamp(1.2rem, 4vw, 1.8rem);\n  color: var(--secondary-text);\n  margin-bottom: 1rem;\n  font-weight: bold;\n}\n\n.fizzbuzz-sequence {\n  font-size: clamp(1rem, 3vw, 1.2rem);\n  color: var(--secondary-text);\n  line-height: 1.6;\n}\n\n/* Input styles */\ninput[type=\"number\"] {\n  background-color: var(--accent-color);\n  color: var(--primary-text);\n  border: none;\n  padding: 0.8rem 1.2rem;\n  border-radius: var(--border-radius);\n  margin-top: 1rem;\n  font-size: 1rem;\n  width: 100%;\n  max-width: 300px;\n  transition: all var(--transition-speed) ease;\n}\n\ninput[type=\"number\"]:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--primary-bg);\n  transform: scale(1.02);\n}\n\ninput[type=\"number\"]::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Weather display styles */\n.weather-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  width: 100%;\n  max-width: 800px;\n  margin: 2rem auto;\n}\n\n.weather-item {\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 1rem;\n  border-radius: var(--border-radius);\n  transition: transform var(--transition-speed) ease;\n}\n\n.weather-item:hover {\n  transform: translateY(-5px);\n}\n\n/* Error message styles */\n.error-message {\n  color: var(--error-color);\n  background-color: rgba(255, 68, 68, 0.1);\n  padding: 1rem;\n  border-radius: var(--border-radius);\n  margin: 1rem 0;\n  width: 100%;\n  max-width: 600px;\n}\n\n/* Loading state styles */\n.loading-spinner {\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-left-color: var(--accent-color);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 2rem auto;\n}\n\n/* Animations */\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .App-header {\n    padding: 1rem;\n  }\n\n  .weather-container {\n    grid-template-columns: 1fr;\n  }\n\n  .fizzbuzz-container {\n    padding: 1.5rem;\n  }\n\n  .main-nav {\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .App-logo {\n    height: 30vmin;\n  }\n\n  .App-title {\n    font-size: 1.8rem;\n  }\n\n  input[type=\"number\"] {\n    padding: 0.6rem 1rem;\n  }\n}\n\n/* Print styles */\n@media print {\n  .App-header {\n    background-color: white;\n    color: black;\n  }\n\n  .App-link {\n    color: black;\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
